import { render, staticRenderFns } from "./AdInsightsContent.vue?vue&type=template&id=354bace5&scoped=true"
import script from "./AdInsightsContent.vue?vue&type=script&lang=js"
export * from "./AdInsightsContent.vue?vue&type=script&lang=js"
import style0 from "./AdInsightsContent.vue?vue&type=style&index=0&id=354bace5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354bace5",
  null
  
)

export default component.exports